import React, { useCallback, useEffect, useRef, useState } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Character, 
} from "@dndModels";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import CharacterSpeed from "@dndComponents/character/misc/CharacterSpeed";
import ModalOrDrawer from "@components/display/ModalOrDrawer";

interface Props {
  character: Character;
}

const char_util = DandDCharacterUtilities.getInstance();

const speed_map = {
  "walk": "Walking",
  "swim": "Swimming",
  "climb": "Climbing",
  "fly": "Flying",
  "burrow": "Buttowing"
};

export default function CharacterSpeedButton({
  character,
}: Props) {
  const [open, setOpen] = useState(false);
  const [speed, setSpeed] = useState(0);
  const [display_speed, setDisplaySpeed] = useState("Walking");
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const recalculated = useCallback(() => {
    setTimeout(() => {
      setSpeed(char_util.getSpeed(character.char_interface, character.char_interface.display_speed));
    }, 100);
  }, [character]);

  const displayChanged = useCallback(() => {
    console.log("Display Changed");
    setTimeout(() => {
      setDisplaySpeed(speed_map[character.char_interface.display_speed]);
      setSpeed(char_util.getSpeed(character.char_interface, character.char_interface.display_speed));
    }, 100);
  }, [character]);

  useEffect(() => {
    character.subscription_holder.subscribe("Recalculated", mounted, recalculated);
    character.subscription_holder.subscribe("Display", mounted, displayChanged);
    displayChanged();
  }, [character, recalculated, displayChanged]);

  const renderExtras = () => {
    return (
      <ModalOrDrawer
        open={ open } 
        onClose={() => {
          setOpen(false);
          character.subscription_holder.modalClosed();
        }}>
        { open &&
          <CharacterSpeed 
            character={character}
            char_interface={character.char_interface}
            disabled={false}
          />
        }
      </ModalOrDrawer>
    );
  }

  return (
    <>
      <Grid container spacing={0} direction="column" className="clickable"
        onClick={() => {
          setOpen(true);
        }}>
        <Grid>
          <div className="centered" style={{
            fontSize: "11px",
            fontWeight: "bold",
          }}>
            { display_speed }
          </div>
        </Grid>
        <Grid>
          <div className="centered" style={{
            fontSize: "24px",
            fontWeight: "bold",
          }}>
            { speed } ft
          </div>
        </Grid>
        <Grid>
          <div className="centered" style={{
            fontSize: "11px",
            fontWeight: "bold",
          }}>
            Speed
          </div>
        </Grid>
      </Grid>
      { renderExtras() }
    </>
  ); 
}

